import { render } from "./LocationFormL2.vue?vue&type=template&id=5b6c226c"
import script from "./LocationFormL2.vue?vue&type=script&lang=js"
export * from "./LocationFormL2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__